<template>
  <div id="product-documents-dynamic-create">

    <dynamic-form @type="type = $event"
                  v-if="model"
                  v-model="model" ref="form" :forms="formReferences"
                  :apiModel="apiModel" />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'dynamic.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create()"
              class="my-4"
              color="light"
          >
            Upload
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DynamicForm from "@/views/pages/product-documents/dynamic/DynamicForm";
import ProductDocumentCreateMixin from "@/components/mixins/ProductDocumentCreateMixin";

export default {
  name: "DynamicCreate",
  components: {
    DynamicForm,
  },
  mixins: [ProductDocumentCreateMixin],
  data() {
    return {
      apiModel: 'productDynamic',
      type: '',
    };
  },
};
</script>

<style scoped>

</style>
